import * as React from 'react';
import {
    Datagrid,
    DateField,
    DateTimeInput,
    DeleteWithConfirmButton,
    downloadCSV,
    FunctionField,
    List,
    TextField,
    TextInput,
} from 'react-admin';
import jsonExport from 'jsonexport/dist';
import { Stack } from '@mui/material';
import { Chip } from '@material-ui/core';

const userFilters = [
    <TextInput
        source="query"
        label={'Név/Telefonszám'}
        name={'query'}
        fullWidth
        required
    />,
    <TextInput
        source="email"
        label={'E-mail'}
        name={'email'}
        fullWidth
        required
    />,
    <TextInput
        source="partnerId"
        label={'Partner kód'}
        name={'partnerId'}
        fullWidth
        required
    />,
    <TextInput
        source="consumerLocation"
        label={'Fogyasztási hely'}
        name={'consumerLocation'}
        fullWidth
        required
    />,
    <DateTimeInput
        source="registeredFrom"
        name={'registeredFrom'}
        label={'Regisztrált ettől'}
    />,
    <DateTimeInput
        source="registeredUntil"
        name={'registeredUntil'}
        label={'Regisztrált eddig'}
    />,
];

const exporter = (
    records: any[],
    fetchRelatedRecords: (arg0: any, arg1: string, arg2: string) => Promise<any>
) => {
    fetchRelatedRecords([], 'id', 'web-user').then(() => {
        const data = records.map((record: any) => ({
            ...record,
        }));
        return jsonExport(
            data,
            {
                headers: ['id', 'name', 'phone', 'email', 'registeredAt'],
                rename: [
                    'ID',
                    'Név',
                    'Telefonszám',
                    'E-mail',
                    'Regisztrálás ideje',
                ],
            },
            (err, csv) => {
                downloadCSV(csv, 'felhasznalok');
            }
        );
    });
};

export const WebUserList = () => (
    <List
        title={'Felhasználók'}
        exporter={exporter}
        sort={{ field: 'Default', order: 'DESC' }}
        filters={userFilters}
        sx={{ marginBottom: '50px' }}
    >
        <Datagrid bulkActionButtons={false} rowClick={'show'}>
            <TextField source="name" label={'Név'} sortable={false} />
            <TextField source="email" label={'E-mail'} />
            <FunctionField
                label="Partner azonosítók"
                sortable={false}
                render={(record: any) => (
                    <Stack
                        direction={'row'}
                        spacing={1}
                        flexWrap={'wrap'}
                        useFlexGap
                    >
                        {record.partnerIds?.map((partnerId: string) => (
                            <Chip
                                key={partnerId}
                                label={partnerId}
                                size="small"
                                style={{ cursor: 'pointer' }}
                            />
                        ))}
                    </Stack>
                )}
            />
            <FunctionField
                label="Fogyasztási helyek"
                sortable={false}
                render={(record: any) => (
                    <Stack
                        direction={'row'}
                        spacing={1}
                        flexWrap={'wrap'}
                        useFlexGap
                    >
                        {record.consumerLocations?.map((location: string) => (
                            <Chip
                                key={location}
                                label={location}
                                size="small"
                                style={{ cursor: 'pointer' }}
                            />
                        ))}
                    </Stack>
                )}
            />
            <DateField
                source="registeredAt"
                locales={['hu-HU']}
                label={'Regisztrálás ideje'}
                sortable={false}
            />
            <FunctionField
                label=""
                render={(record: any) => {
                    return record.id < 1 ? null : (
                        <DeleteWithConfirmButton
                            confirmTitle={'Felhasználó eltávolítása'}
                            confirmContent={'A felhasználó véglegesen törlődik'}
                        />
                    );
                }}
            />
        </Datagrid>
    </List>
);
